import { useSyncExternalStore as r } from "./designsystem-ui-react182.js";
function o(e) {
  return r(e.subscribe, e.getSnapshot, e.getSnapshot);
}
export {
  o as useStore
};
